import { Box, Button, Flexbox, Label } from "codekit";
import { useEffect, useRef, useState } from "react";
import useVersionCheck from "../../hooks/useVersionCheck";

const DISMISS_MS = 30 * 60 * 1000;

/**
 * Banner de nueva version: avisa cuando hay un despliegue nuevo del front.
 * El usuario puede actualizar de inmediato o posponer 30 minutos.
 */
const Newverxx = () => {
  const isUpdateAvailable = useVersionCheck();
  const [isDismissed, setIsDismissed] = useState(false);
  const [isReloading, setIsReloading] = useState(false);
  const dismissTimerRef = useRef(null);

  /**
   * Limpia el query ?nv= que se agrega al forzar la recarga del index.html
   */
  useEffect(() => {
    const url = new URL(window.location.href);
    if (url.searchParams.has("nv")) {
      url.searchParams.delete("nv");
      window.history.replaceState({}, "", url.pathname + url.search);
    }
  }, []);

  /**
   * Limpia el timer de posposicion al desmontar
   */
  useEffect(() => {
    return () => clearTimeout(dismissTimerRef.current);
  }, []);

  /**
   * Limpia caches del navegador y fuerza la recarga del index.html fresco
   */
  const handleUpdate = async () => {
    setIsReloading(true);
    try {
      if ("caches" in window) {
        const cacheKeys = await caches.keys();
        await Promise.all(cacheKeys.map((key) => caches.delete(key)));
      }
      if ("serviceWorker" in navigator) {
        const registrations = await navigator.serviceWorker.getRegistrations();
        await Promise.all(registrations.map((r) => r.unregister()));
      }
    } catch {
      // La limpieza de cache no debe impedir la recarga
    }
    window.location.replace(window.location.pathname + "?nv=" + Date.now());
  };

  /**
   * Oculta el banner 30 minutos para que el usuario termine lo que esta haciendo
   */
  const handleDismiss = () => {
    setIsDismissed(true);
    clearTimeout(dismissTimerRef.current);
    dismissTimerRef.current = setTimeout(() => setIsDismissed(false), DISMISS_MS);
  };

  if (!isUpdateAvailable || isDismissed) {
    return null;
  }

  return (
    <div style={{ position: "fixed", bottom: "16px", right: "16px", zIndex: 9999 }}>
      <Box bg='secondary-600' color='white' spacing={4} rounded="md">
        <Flexbox alignItems="center" gap={4}>
          <Label color="white">Nueva versión de CASTOR disponible</Label>
          <Button
            variant="secondary"
            size="m"
            type="button"
            disabled={isReloading}
            onClick={handleDismiss}
          >
            Más tarde
          </Button>
          <Button
            variant="secondary"
            size="m"
            type="button"
            isLoading={isReloading}
            disabled={isReloading}
            onClick={handleUpdate}
          >
            Actualizar
          </Button>
        </Flexbox>
      </Box>
    </div>
  );
};

export default Newverxx;
